import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7a0c69c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1))
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-link" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_update_signers_modal = _resolveComponent("update-signers-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_bids_wait_list_filters = _resolveComponent("bids-wait-list-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.edit_state.is_open)
      ? (_openBlock(), _createBlock(_component_update_signers_modal, {
          key: 0,
          loading: _ctx.edit_state.is_loading,
          signers: _ctx.edit_state.signers,
          onConfirm: _ctx.editSigners,
          onCancel: _ctx.toggleEditSigners
        }, null, 8, ["loading", "signers", "onConfirm", "onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_page_title, { title: "На подписании" })
      ]),
      _createVNode(_component_bids_wait_list_filters, {
        class: "mt-6",
        loading: _ctx.data_state.is_loading,
        onSearch: _ctx.applyFilters,
        onResetted: _ctx.resetFilters
      }, null, 8, ["loading", "onSearch", "onResetted"]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.data_state.is_failed && !_ctx.data_state.failure.error_state.is_cancel)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.data_state.is_loading,
              text: "При получении списка заявок произошла ошибка",
              "error-message": _ctx.data_state.failure.error_state.message,
              "error-url": _ctx.data_state.failure.error_state.url,
              "error-status": _ctx.data_state.failure.error_state.status,
              onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadBidsOnSign(_ctx.data_state.pagination.current_page)))
            }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
          : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
              key: 1,
              loading: _ctx.data_state.is_loading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_table, {
                  loading: _ctx.data_state.is_loading,
                  columns: _ctx.BidsWaitListColumns,
                  rows: _ctx.data_state.list,
                  "with-limit": "",
                  "pagination-limit": _ctx.filters_state.limit,
                  "pagination-total-items": _ctx.data_state.pagination.total_items,
                  "pagination-current-page": _ctx.data_state.pagination.current_page,
                  "pagination-total-pages": _ctx.data_state.pagination.total_pages,
                  onChangePage: _ctx.loadBidsOnSign,
                  onChangeLimit: _ctx.onLimitChange
                }, {
                  td: _withCtx(({ row, column }) => [
                    (row.carrier && column.key === 'carrier')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(row.carrier.name), 1)
                        ], 64))
                      : (column.key === 'signers')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(row[column.key], (signer, i) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: `BidSigner-${i}`
                            }, _toDisplayString(signer.email) + " - " + _toDisplayString(_ctx.getContractStatus(signer.isSigned, signer.typeId)), 1))
                          }), 128))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(row[column.key]), 1)
                          ], 64))
                  ]),
                  actions: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_the_button, {
                        hint: "Редактировать подписантов",
                        class: "primary extra-small",
                        onClick: ($event: any) => (_ctx.toggleEditSigners(row)),
                        loading: _ctx.check_state.is_loading,
                        disabled: _ctx.check_state.is_loading
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 2
                      }, 1032, ["onClick", "loading", "disabled"]),
                      _createVNode(_component_the_button, {
                        hint: "Проверка договора",
                        class: "primary extra-small ml-3",
                        onClick: ($event: any) => (_ctx.checkIsSigned(row.id)),
                        loading: _ctx.check_state.is_loading,
                        disabled: _ctx.check_state.is_loading
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 2
                      }, 1032, ["onClick", "loading", "disabled"]),
                      _createElementVNode("a", {
                        target: "_blank",
                        class: "ml-3",
                        href: row.dogovor24Url
                      }, [
                        _createVNode(_component_the_button, {
                          hint: "Ссылка на Договор24",
                          class: "primary extra-small"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_7),
                      _createVNode(_component_the_button, {
                        hint: "Удалить заявку",
                        class: "red extra-small ml-3",
                        onClick: ($event: any) => (_ctx.deleteBid(row.id)),
                        loading: _ctx.delete_state.is_loading,
                        disabled: _ctx.delete_state.is_loading
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 2
                      }, 1032, ["onClick", "loading", "disabled"])
                    ])
                  ]),
                  _: 1
                }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
              ]),
              _: 1
            }, 8, ["loading"]))
      ])
    ])
  ], 64))
}